// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";

import { getImage } from "assets/Images";

export default function HomeHeader() {
	return (
		<MDBox
			component="header"
			position="absolute"
			top={0}
			left={0}
			display="flex"
			alignItems="center"
			width="100%"
			height="80px"
			px="30px"
			zIndex={4}
			sx={{ backgroundColor: "#444041", borderBottom: "1px solid #AAAAAA" }}
		>
			<MDBox
				component="img"
				src={getImage("logodigihapi")}
				alt="DigiHapi logo"
				title="DigiHapi logo"
				height="60px"
			/>
		</MDBox>
	);
}
